import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() =>
	createStyles({
		root: {
			height: '70px',
		},
		// The redesigned layout's default look — every guided-setup component
		// reads as a card, not a plain row.
		card: {
			height: 'auto',
			border: '1px solid #e3e7ed',
			borderRadius: '6px',
			padding: '16px',
			marginBottom: '10px',
			backgroundColor: '#fbfcfd',
			transition: 'box-shadow .2s, border-color .2s, background .2s',
			'&:hover': {
				background: '#fff',
				boxShadow:
					'0 1px 2px rgba(16,24,40,.04), 0 6px 20px rgba(16,24,40,.05)',
				borderColor: '#d3d9e1',
			},
		},
		margin: {
			height: '3rem',
		},
		titleWCheckbox: {
			maxWidth: 'calc( 100% - 20px)',
		},
	}),
);
